import React from "react";
import { Grid, Box, Typography, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { useProyecto } from "../../../data/ProyectoContext";
import { iProyectoABP } from "../../../interfaces/Proyecto/iProyecto";

const ProjectName = () => {
  const { proyecto, setProyecto } = useProyecto();

  const handleNameProyectChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = event.target;
    setProyecto((prev) => ({ ...prev, tema: value }));
  };

  return (
    <Grid item xs={12} sm={12} sx={{ mt: 1.8 }}>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          Tema *
        </Typography>
      </Box>
      <TextField
        required
        id="nombre_proyecto"
        placeholder="Ingrese el tema del proyecto"
        name="nombre"
        value={(proyecto as iProyectoABP).tema}
        fullWidth
        autoComplete="given-name"
        variant="outlined"
        onChange={handleNameProyectChange}
        InputProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            mb: 3,
            fontFamily: "montserrat",
            fontSize: "0.75rem",
            color: "#005559",
            "&::placeholder": {
              color: "#005559",
            },
            "&:before": {
              borderBottomColor: "#005559",
            },
            "&:after": {
              borderBottomColor: "#005559",
            },
          },
        }}
      />
    </Grid>
  );
};

export default ProjectName;
